/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseOwnerField
 */
export interface DatabaseOwnerField extends DatabaseField {
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseOwnerField
     */
    ownerFields?: Array<string>;
}

/**
 * Check if a given object implements the DatabaseOwnerField interface.
 */
export function instanceOfDatabaseOwnerField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseOwnerFieldFromJSON(json: any): DatabaseOwnerField {
    return DatabaseOwnerFieldFromJSONTyped(json, false);
}

export function DatabaseOwnerFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseOwnerField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'ownerFields': !exists(json, 'ownerFields') ? undefined : json['ownerFields'],
    };
}

export function DatabaseOwnerFieldToJSON(value?: DatabaseOwnerField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'ownerFields': value.ownerFields,
    };
}

